<template>
  <div>
    <div class="row">
      <Breadcrumbs v-if="breadcrumbsData !== null" v-bind:parameters="breadcrumbsData"></Breadcrumbs>
    </div>
    <div class="row">
      <div class="col-12 gallery-grid-count-col d-none d-md-block">
        <div @click="selecrGrid(grid)" v-for="grid in grids" :class="'gallery-grid-count count-' + grid + ((grid === activeGrid) ? ' active' : '')">
          <div class="gallery-grid-count__item">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <div class="row gallery-img">
      <div v-for="photo in photos" :class="imgClass">
        <div class="gallery-img__item">
          <p>{{ photo.date }}</p>
          <img :src="photo.filename" :alt="photo.date" class="img-gallery-grid" @click="openModalPageGallery">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment'
import axios from 'axios'
import Breadcrumbs from '@/components/Breadcrumbs'

export default {
  name: 'Gallery',
  components: { Breadcrumbs },
  data () {
    return {
      photos: [],
      breadcrumbsData: null,
      from: moment(moment()
        .valueOf() - 48 * 60 * 60000)
        .format('YYYY-MM-DD HH:mm:ss'),
      to: moment(this.from)
        .format('YYYY-MM-DD HH:mm:ss'),
      grids: [
        1,
        2,
        3,
        4
      ],
      activeGrid: 4
    }
  },
  created () {
    let id = this.$route.params.id
    let _this = this

    this.$store.dispatch('station/findOne', id)
      .then((station) => {
        _this.breadcrumbsData = [
          {
            url: '/station-view/' + station.id,
            title: station.title
          },
          {
            url: '/weather/' + station.id,
            title: station.title + ' (Weather)'
          },
          {
            url: '#',
            title: station.title + ' (Gallery)'
          }
        ]
        //      _this.title = station.title + ' (' + station.totalPower + ' MW)'
      })
      .catch()

    this.fetchPhotos()
  },
  computed: {
    imgClass () {
      let classes = ['gallery-img__col']
      classes.push('grid-' + this.activeGrid)

      return classes
    }
  },
  methods: {
    openModalPageGallery (event) {
      removeModal()

      function removeModal () {
        let removeElements = document.getElementsByClassName('modal-single-photo')
        for (let i = 0; i < removeElements.length; i++) {
          removeElements[ i ].remove()
        }
      }

      let beforeWidth = document.documentElement.clientWidth

      let img = new Image()
      img.src = event.target.getAttribute('src')

      let div = document.createElement('div')
      div.className = 'modal-single-photo'
      div.innerHTML = "<div class='modal-single-photo__close'></div><div class='modal-single-photo__img'><div class='modal-single-photo__img_img'><div class='modal-single-photo-prev'><div></div></div><div class='modal-single-photo-next'><div></div></div><div class='modal-single-photo__img_close'></div></div></div>"
      document.body.append(div)
      document.getElementsByClassName('modal-single-photo__img_img')[ 0 ].append(img)
      document.body.classList.add('body-modal-photo')
      let afterWidth = document.documentElement.clientWidth

      if (beforeWidth < afterWidth) {
        let newWidth = afterWidth - beforeWidth
        document.body.style.paddingRight = newWidth + 'px'
        document.getElementById('header_').style.paddingRight = newWidth + 'px'
        document.getElementsByClassName('modal-single-photo__close')[ 0 ].style.right = newWidth + 'px'
        document.getElementsByClassName('modal-single-photo__img_close')[ 0 ].style.right = newWidth + 'px'
      }

      const thisElem = event.target.parentElement.parentElement
      const allElem = document.getElementsByClassName('gallery-img__col')
      let index
      for (let i = 0; i < allElem.length; i++) {
        if (allElem[ i ] === thisElem) {
          index = i
          break
        }
      }

      function removeModalStyle () {
        removeModal()
        document.body.classList.remove('body-modal-photo')
        document.body.style.paddingRight = ''
        document.getElementById('header_').style.paddingRight = ''
      }

      document.getElementsByClassName('modal-single-photo__img')[ 0 ].addEventListener('click', function (e) {
        let div = document.getElementsByClassName('modal-single-photo__img')[ 0 ]
        if (div === e.target) {
          removeModalStyle()
        }
      })

      document.getElementsByClassName('modal-single-photo__close')[ 0 ].addEventListener('click', function () {
        removeModalStyle()
      })
      document.getElementsByClassName('modal-single-photo__img_close')[ 0 ].addEventListener('click', function () {
        removeModalStyle()
      })

      function clickNext () {
        index++
        if (index >= allElem.length) {
          index = allElem.length - 1
        }
        arrows()
      }

      function arrows () {
        let imgNew = new Image()
        imgNew.src = allElem[ index ].getElementsByClassName('img-gallery-grid')[ 0 ].getAttribute('src')
        let oldImg = document.getElementsByClassName('modal-single-photo__img_img')[ 0 ].getElementsByTagName('img')[ 0 ].remove()
        document.getElementsByClassName('modal-single-photo__img_img')[ 0 ].append(imgNew)
      }

      function clickPrev () {
        index--
        if (index <= 0) {
          index = 0
        }
        arrows()
      }

      document.getElementsByClassName('modal-single-photo-prev')[ 0 ].addEventListener('click', function () {
        clickPrev()
      })
      document.getElementsByClassName('modal-single-photo-next')[ 0 ].addEventListener('click', function () {
        clickNext()
      })
    },

    fetchPhotos () {
      let _this = this

      axios.get('https://tel.pvcontrol.solar/pvcontrol/api/period', {
        params: {
          'stationId': this.$route.params.id,
          'startDate': this.from,
          'endDate': this.to
        }
      })
        .then((r) => {
          _this.photos = r.data.sort(function (a, b) {
            if (a.date > b.date) {
              return -1
            }
            if (b.date > a.date) {
              return 1
            }
            // a must be equal to b
            return 0
          })
        })
    },
    selecrGrid (grid) {
      this.activeGrid = grid
    }
  }
}
</script>

<style scoped>

</style>
